import { ICloneType } from "./cloneTypes";
import { ICountry } from "./country";
import { IIndustry } from "./industry";
import { ISoldInformation } from "./soldInformation";
import { IHost } from "./users";

export enum CloneStatus {
  ACTIVE = "active",
  PAUSE = "pause",
}
export interface ICompanyPresentation {
  file: string;
  image: string;
  title: string;
}

export interface IClone {
  id: number;
  slug: string;
  company_presentation: ICompanyPresentation[];
  logo: string;
  main_photo: string;
  company_name: string;
  google_profile: string;
  website: string;
  describe_product: string;
  advantages: string;
  investment_for_start: number;
  years_on_market: string;
  customers_count: string;
  company_turnover_min: number;
  company_turnover_max: number;
  average_turnover: number;
  ready_to_authorized_capital: boolean;
  patents_brands: boolean;
  patents_brands_text: string;
  clone_cost: number;
  activities: string;
  company_clients: string;
  support_buyer: string;
  additional_information: string;
  created_at: string;
  updated_at: string;
  employees: string;
  monthly_income_min: number;
  monthly_income_max: number;
  average_income: number;
  access_to_production: boolean;
  status: CloneStatus;
  clone_type: ICloneType;
  industry: IIndustry;
  views_count: number;
  saved_count: number;
  isFavorite: boolean;
  information_sold: ISoldInformation[];
  host: IHost;
  is_active_deal: boolean;
  is_host: boolean;
  prohibited_countries: ICountry[];
  clone_meta_title: string;
  clone_meta_description: string;
}
